module.exports = __webpack_public_path__ + "img/3-mob-wide.b800ad29.png";